import {linkSalesRepresentativesIndex} from "helpers/links-builders/sales-representatives-links";
import {ICountryAssetLite} from "models/Assets/ICountryAsset";
import {isShobiddak} from "helpers/osHelpers";


const contacts = (
    protocol: string,
    country: ICountryAssetLite,
    domain: string,
    translations?:any
) => [
  {
    id: 1,
    href: {
      ar: isShobiddak() ? `info@shobiddak.com ` : `mailto:${country?.contact_info?.email}`,
      en: isShobiddak() ? `info@shobiddak.com ` : `mailto:${country?.contact_info?.email}`,
    },
    hrefLabel_en: isShobiddak()?`info@shobiddak.com `:`${country?.contact_info?.email}`,
    hrefLabel_ar: isShobiddak()?`info@shobiddak.com `:`${country?.contact_info?.email}`,
    fill: "#0179FF",
    icon: "emailSvg",
    label_en: "Email",
    label_ar: "البريد الالكتروني",
  },

  country?.contact_info?.os_phone_number
      ? {
        id: 2,
        href: {
          ar: `tel:${country?.contact_info?.whatsapp}`,
          en: `tel:${country?.contact_info?.whatsapp}`,
        },
        hrefLabel_en: country?.contact_info?.phone_number,
        hrefLabel_ar: country?.contact_info?.phone_number,
        icon: "telePhoneSvg",
        fill: "#0179FF",
        label_en: "Phone",
        label_ar: "الهاتف",
      }
      : {
        id: 2,
        href: {
          ar: "/ar/مساعدة",
          en: "/en/support",
        },
        hrefLabel_ar: translations.contactUs,
        hrefLabel_en: translations.contactUs,
        icon: "telePhoneSvg",
        fill: "#0179FF",
        label_en: "Phone",
        label_ar: "الهاتف",
      },
  {
    id: 3,
    href: {
      ar: `https://api.whatsapp.com/send/?phone=${country?.contact_info?.whatsapp.replace(/\+|\s/g, '')}&text&type=phone_number&app_absent=0`,
      en: `https://api.whatsapp.com/send/?phone=${country?.contact_info?.whatsapp.replace(/\+|\s/g, '')}&text&type=phone_number&app_absent=0`,
    },
    hrefLabel_en: translations.contactUsVia,
    hrefLabel_ar: translations.contactUsVia,
    icon: "IconWhatsapp",
    fill: "#25D366",
    label_en: "Whatsapp",
    label_ar: "واتساب",
  },
  {
    id: 4,
    href: {
      ar: linkSalesRepresentativesIndex(),
      en: linkSalesRepresentativesIndex(),
    },
    hrefLabel_en: isShobiddak()?"shobiddak/sales":"opensooq/sales",
    hrefLabel_ar: isShobiddak()?"shobiddak/sales":"opensooq/sales",
    icon: "salesSvg",
    fill: "#0179FF",
    label_en: "Contact Sales",
    label_ar: "تواصل مع المندوبين",
  },
];


export {contacts};
